import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import NotificationIcon from "@mui/icons-material/Notifications";
import { Badge, Box, Button, IconButton, List, ListItem, ListItemText, Popover, Tab, Tabs, } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useListNotifications, useMarkNotificationAsRead, } from "../api/NotificationApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import ErrorSnackbar from "../utils/ErrorSnackbar";
const VERB_TO_URL = {
    transfer_request: (action) => `/transfers/${action.id}`,
    transfer_request_accepted: (_action, target) => `/teams/${target.id}`,
    team_player_invitation: (action) => `/invitations/${action.id}`,
    team_player_invitation_accepted: (_action, target) => `/teams/${target.id}`,
    league_team_invitation: (action) => `/league-invitations/${action.id}`,
    league_team_invitation_accepted: (_action, target) => `/leagues/${target.id}`,
    team_ownership_invitation: (action) => `/ownership-invitations/${action.id}`,
    team_ownership_invitation_accepted: (_action, target) => `/teams/${target.id}`,
    team_assistant_manager_added: (_action, target) => `/teams/${target.id}`,
};
export const buildNotificationUrl = (notification) => {
    const action = notification.actionObject;
    const target = notification.target;
    return VERB_TO_URL[notification.verb](action, target);
};
export const NotificationsBadge = () => {
    const { data: allNotifications, isLoading: notificationsIsLoading, error: notificationsError, } = useListNotifications({});
    const markNotificationAsReadMutation = useMarkNotificationAsRead();
    const [anchorEl, setAnchorEl] = useState(null);
    const [tabValue, setTabValue] = useState("all");
    const navigate = useNavigate();
    const notifications = tabValue === "all"
        ? allNotifications?.results
        : allNotifications?.results?.filter((n) => n.unread);
    const handleBadgeClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleNotificationClick = (notification) => {
        if (notification.unread) {
            markNotificationAsReadMutation.mutate(notification.id);
        }
        navigate(buildNotificationUrl(notification));
        handleClose();
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const handleTabChange = (_event, newValue) => {
        setTabValue(newValue);
    };
    const unreadCount = allNotifications?.unreadCount ?? 0;
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: !!notificationsError, message: "Failed to load user notifications!" }), _jsx(IconButton, { sx: { color: "white" }, onClick: handleBadgeClick, children: _jsx(Badge, { color: "secondary", badgeContent: notificationsIsLoading ? "..." : unreadCount, children: _jsx(NotificationIcon, {}) }) }), _jsx(Popover, { open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right",
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "right",
                }, children: _jsx(React.Fragment, { children: notificationsIsLoading ? (_jsx(Loading, {})) : notificationsError || !notifications ? (_jsx(ErrorView, {})) : (_jsxs(_Fragment, { children: [_jsx(Box, { sx: { p: 1, borderBottom: 1, borderColor: "divider" }, children: _jsxs(Tabs, { value: tabValue, onChange: handleTabChange, centered: true, children: [_jsx(Tab, { label: "All", value: "all" }), _jsx(Tab, { label: "Unread", value: "unread" })] }) }), _jsx(List, { children: notifications.length === 0 ? (_jsx(ListItem, { children: _jsx(ListItemText, { primary: "No new notifications" }) })) : (notifications.map((notification) => (_jsxs(ListItem, { onClick: () => handleNotificationClick(notification), sx: {
                                        bgcolor: notification.unread ? "#f0f0f0" : "white",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        cursor: "pointer",
                                    }, children: [_jsx(ListItemText, { primary: notification.description }), notification.unread && (_jsx(Box, { "data-testid": "unread-dot", sx: {
                                                width: 10,
                                                height: 10,
                                                bgcolor: "blue",
                                                borderRadius: "50%",
                                                ml: 2,
                                            } }))] }, notification.id)))) }), _jsx(Box, { sx: {
                                    textAlign: "center",
                                    p: 1,
                                    borderTop: 1,
                                    borderColor: "divider",
                                }, children: _jsx(Button, { size: "small", onClick: () => {
                                        navigate("/notifications");
                                        handleClose();
                                    }, children: "See All" }) })] })) }) })] }));
};
